import * as React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

interface AuthCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

export function AuthCard({ title, description, children }: AuthCardProps) {
  return (
    <main
      className="min-h-screen bg-brand-radial flex items-center justify-center p-4"
      role="main"
    >
      <Card className="w-full max-w-md glass-heavy border-0">
        <CardHeader className="text-center">
          <CardTitle className="text-3xl text-white font-heading tracking-tight">{title}</CardTitle>
          {description && (
            <CardDescription className="text-brand-muted">{description}</CardDescription>
          )}
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </main>
  );
}
